import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-sidebar-item',
})
export class SignetSidebarItem {
  @Prop() icon: string;
  @Prop() text: string;
  @Prop() active = false;
  @Prop() handleClick: () => void;

  render() {
    const classes = {
      'sidebar-item': true,
      active: this.active,
    };

    const activeClass = {
      activeBar: this.active,
    };

    return (
      <div class={classes} onClick={this.handleClick}>
        <div class={activeClass} />
        <signet-icon icon={this.icon} class="icon" />
        <p class="text">{this.text}</p>
      </div>
    );
  }
}
